<template>
  <div class="chapter-content" :id="period.id">
    <div
      class="period-header clearfix"
      :class="{ 'period-header-7': courseType == 7, opacity: period.limit }"
    >
      <div style="flex: 1">
        <div v-if="period.limit" class="limitDiv">限制访问</div>
        <div
          class="period-title-wrapper"
          :class="{
            disabled: !$services.CourseService.checkLiveState(courseType, period),
          }"
          @click="targetPeriod(period, 1)"
        >
          <!-- <span class="period-point"></span> -->
          <CoursePeriodsType :periods_type="courseType" :short="true"></CoursePeriodsType>
          <!-- <span class="period-try" v-if="period.is_try_see">试看</span> -->
          <span
            class="period-title"
            :style="{
              cursor:
                courseType == 5 || courseType == 8 || courseType == 10 ? 'pointer' : 'default',
            }"
            :title="period.periods_title"
          >
            {{ period.periods_title }}
          </span>
          <span class="progress-wrap" v-if="false && (courseType == 5 || courseType == 8)">
            <ProgressBar
              v-if="period.progress_rate < 100"
              class="progress"
              :value="period.progress_rate"
              type="pie"
              backColor="white"
              foreColor="#fc5623"
              style="width: 16px; border: 1px solid #fc5623; border-radius: 50%"
            ></ProgressBar>
            <i v-else class="el-icon-success"></i>
            <span>{{ period.progress_rate }}%</span>
          </span>
        </div>
        <FileList ref="fileList" :fileList="getFile(period.files)" :period="period" />
        <div class="period-info" v-if="courseType != 10">
          <div class="period-state" v-if="courseType != 5">
            <span v-if="period.start_play">
              {{ period.start_play + ' - ' + period.end_play }}
            </span>
            <template v-if="[2, 3, 7, 15, 16].includes(courseType)">
              <i class="line" v-if="period.play_type" />
              <div v-if="period.play_type === 1" class="state notStart">
                <img src="@/assets/images/course/time_line.png" />
                未开课
              </div>
              <div v-if="period.play_type === 2" class="state inClass">
                <img src="@/assets/images/course/inClass.gif" />
                上课中
              </div>
              <div v-if="[3, 4, 5].includes(period.play_type)" class="state end">
                <img src="@/assets/images/course/correct_line.png" />
                已完课
              </div>
            </template>
          </div>
          <!-- <div v-if="courseType != 5 && courseType != 8" class="period-teacher">
            {{ period.teacher_name }}
          </div> -->
          <div v-if="period.homework" class="tip" v-html="getHomeworkTip(period.homework)" />
          <div class="serve-warp">
            <div
              v-if="period.homework"
              class="serve-item"
              @click="handleGoHomework(period.homework)"
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="file_paper_line ">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.36766 2.30078L13.3337 6.26678V13.6341C13.3337 14.7341 12.4337 15.6341 11.3337 15.6341H4.66699C3.56699 15.6341 2.66699 14.7341 2.66699 13.6341V4.30078C2.66699 3.20078 3.56699 2.30078 4.66699 2.30078H9.36766ZM8.00033 3.63411H4.66699C4.30566 3.63411 4.00033 3.93945 4.00033 4.30078V13.6341C4.00033 13.9954 4.30566 14.3008 4.66699 14.3008H11.3337C11.695 14.3008 12.0003 13.9954 12.0003 13.6341V7.63411H8.66699C8.29833 7.63411 8.00033 7.33611 8.00033 6.96745V3.63411ZM7.33366 10.9674C7.70185 10.9674 8.00033 11.2659 8.00033 11.6341C8.00033 12.0023 7.70185 12.3008 7.33366 12.3008H6.00033C5.63214 12.3008 5.33366 12.0023 5.33366 11.6341C5.33366 11.2659 5.63214 10.9674 6.00033 10.9674H7.33366ZM10.0003 8.96745C10.3685 8.96745 10.667 9.26592 10.667 9.63411C10.667 10.0023 10.3685 10.3008 10.0003 10.3008H6.00033C5.63214 10.3008 5.33366 10.0023 5.33366 9.63411C5.33366 9.26592 5.63214 8.96745 6.00033 8.96745H10.0003ZM9.33366 4.15278V6.30078H11.4817L9.33366 4.15278Z"
                    fill="currentColor"
                    fill-opacity="0.9"
                  />
                </g>
              </svg>
              <span>课后作业</span>
            </div>
            <div
              v-if="period.report_status"
              class="serve-item"
              @click="handleGoStudyReport(period.report_status)"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="evaluation_line">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 1.33203C10.3682 1.33203 10.6667 1.63051 10.6667 1.9987H12C13.1046 1.9987 14 2.89413 14 3.9987V12.6654C14 13.7699 13.1046 14.6654 12 14.6654H4C2.89543 14.6654 2 13.7699 2 12.6654V3.9987C2 2.89413 2.89543 1.9987 4 1.9987H5.33333C5.33333 1.63051 5.63181 1.33203 6 1.33203H10ZM5.33333 3.33203H4C3.63181 3.33203 3.33333 3.63051 3.33333 3.9987V12.6654C3.33333 13.0336 3.63181 13.332 4 13.332H12C12.3682 13.332 12.6667 13.0336 12.6667 12.6654V3.9987C12.6667 3.63051 12.3682 3.33203 12 3.33203H10.6667L10.6622 3.40978C10.6237 3.74134 10.3419 3.9987 10 3.9987H6C5.63181 3.9987 5.33333 3.70022 5.33333 3.33203ZM10 10.6654C10.3682 10.6654 10.6667 10.9638 10.6667 11.332C10.6667 11.7002 10.3682 11.9987 10 11.9987H6C5.63181 11.9987 5.33333 11.7002 5.33333 11.332C5.33333 10.9638 5.63181 10.6654 6 10.6654H10ZM10.3235 5.42239C10.5839 5.68274 10.5839 6.10485 10.3235 6.3652L7.49509 9.19362C7.23474 9.45397 6.81263 9.45397 6.55229 9.19362L5.60948 8.25081C5.34913 7.99047 5.34913 7.56835 5.60948 7.30801C5.86983 7.04766 6.29194 7.04766 6.55229 7.30801L7.02369 7.77941L9.38071 5.42239C9.64106 5.16204 10.0632 5.16204 10.3235 5.42239Z"
                    fill="currentColor"
                  />
                </g>
              </svg>
              <span>学习报告</span>
            </div>
          </div>
        </div>
      </div>
      <div class="period-btn" v-if="[2, 3, 15, 16].includes(courseType)">
        <div
          v-if="[3, 4, 5].includes(period.play_type)"
          @click.stop="targetPeriod(period, 1)"
          class="btn"
        >
          查看回放
        </div>
        <div
          v-if="period.play_type === 1"
          @click.stop="targetPeriod(period, 1)"
          class="btn disabled"
        >
          进入教室
        </div>
        <div v-if="period.play_type === 2" @click.stop="targetPeriod(period, 1)" class="btn">
          进入教室
        </div>
      </div>
      <div class="period-btn" v-if="[5, 10].includes(courseType)">
        <div @click.stop="targetPeriod(period)" class="btn">开始学习</div>
      </div>
    </div>
    <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip v-if="showSoldOut" :show.sync="showSoldOut"></CourseSoldOutTip>
    <ContactTeacherDialog
      :visible="showContactTeacherDialog"
      :interceptText="period.interception_info?.interceptText.split('_')[0]"
      :wechatWorkQrCode="period.interception_info?.wechat_work_qr_code"
      @close="showContactTeacherDialog = false"
    />
  </div>
</template>
<script>
import CourseSoldOutTip from '@/modules/stu/components/CourseSoldOutTip.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import FileList from '@/modules/stu/components/FileList';
import CoursePeriodsType from '@/modules/stu/components/CoursePeriodsType';
import CourseContentTip from '@/modules/stu/components/CourseContentTip';
import ContactTeacherDialog from './ContactTeacherDialog';

export default {
  name: 'MemberStudyPeriod',
  components: {
    CourseSoldOutTip,
    ProgressBar,
    FileList,
    CoursePeriodsType,
    CourseContentTip,
    ContactTeacherDialog,
  },
  props: {
    period: {
      type: Object,
    },
    course_type: {
      type: Number,
    },
    course_id: {
      type: Number,
    },
    course_title: {
      type: String,
      default: '',
    },
    course: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showContactTeacherDialog: false,
      showContentDialog: false,
      chapter_content: '',
      showSoldOut: false,
    };
  },
  watch: {
    'period.report_status': function () {
      if (this.period.report_status) {
        this.$webSeeSendTrack({
          event_id: 'study_report_entrance_show',
          event_type: 'show',
          data: {
            course_id: this.course_id,
            course_title: this.course_title,
            course_type: this.course_type,
            periods_id: this.period.periods_id,
            periods_title: this.period.periods_title,
          },
        });
      }
    },
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    courseType() {
      return this.period.periods_type;
    },
  },
  methods: {
    handleGoHomework(homework) {
      if (homework.status === 0) {
        this.$info('作业未解锁');
        return;
      }
      sessionStorage.setItem('backRouter', 'MemberStudy');
      sessionStorage.setItem('memberCourseId', this.course_id);
      if ([1, 11].includes(homework.status)) {
        this.$router.push({
          name: homework.status === 11 ? 'HomeworkDo' : 'HomeworkIntro',
          query: {
            id: homework.report_id,
            hw_id: homework.hw_id,
          },
        });
        return;
      }
      this.$router.push({
        name: 'HomeworkAnalysis',
        query: {
          id: homework.report_id,
          hw_id: homework.hw_id,
          type: homework.status === 6 ? 'correct' : undefined,
        },
      });
    },
    handleGoStudyReport(reportStatus) {
      this.$webSeeSendTrack({
        event_id: 'study_report_entrance_click',
        event_type: 'click',
        data: {
          course_id: this.course_id,
          course_title: this.course_title,
          course_type: this.course_type,
          periods_id: this.period.periods_id,
          periods_title: this.period.periods_title,
          status: reportStatus.status, // 0 未生成 1 未查看 2 已查看
          short_link_code: reportStatus.short_link_code, // 报告码
        },
      });

      if (reportStatus.status === 0) {
        this.$info('报告未生成');
        return;
      }
      window.open(`/h5/study_report?id=${reportStatus.short_link_code}`, '_blank');
    },
    getHomeworkTip(item) {
      // 0待解锁 1待提交「开始作答」「继续作答」、2待批改「答题情况」、6待订正「作答结果」、7已完成「查看结果」。
      const tipMap = {
        0: '开课后解锁作业',
        1: '快来验证一下学习效果吧',
        11: '加把劲儿，就快答完了',
        2: '快马加鞭批改中...',
        6: `你找到了<span style="color: red">${item.number}道错题</span>，快去订正吧`,
        7: '恭喜你完成本次作业',
      };
      const status = item.status;
      return tipMap[status];
    },
    //处理课节课件文件
    getFile(data) {
      if (data && data.length > 0) {
        return data.map((item) => ({
          ...item,
          ware_filename: item.file_name,
        }));
      }
      return [];
    },
    check() {
      if (this.course.status == 2 && this.course.is_go_to_study == 0) {
        this.showSoldOut = true;
        return false;
      }
      return true;
    },
    async visitFile(id, index) {
      if (!this.check()) {
        return;
      }
      await this.$services.CourseService.openPeriodFile(this.period, id, index);
    },
    async targetPeriod(period, type) {
      if (period.interception_info) {
        this.showContactTeacherDialog = true;
        return;
      }
      this.$webSeeSendTrack({
        event_id: 'my_courses_item_detail_click',
        event_type: 'click',
        data: {
          course_id: this.course_id,
          course_title: this.course_title,
          course_type: this.course_type,
        },
      });
      if (period.limit) {
        this.$info('访问被限制，请联系老师');
        return;
      }
      if (!this.check()) {
        return;
      }
      /*
      if (this.period.bjy_encode_status != 1) {
        this.$info("视频转码中，请稍后观看");
        return;
      }
      */
      if (!this.$services.CourseService.checkLiveState(this.courseType, period, type)) {
        return;
      }
      if (this.course.valid_status != 1) {
        this.$info('该课程已过期，无法继续学习');
        return;
      }
      // 混合课面授课弹出课节内容\
      if (this.period.periods_type == 7 && this.period.content) {
        this.chapter_content = this.period.content;
        this.showContentDialog = true;
        return;
      }
      await this.$services.CourseService.checkLimit(this.course_id, period.id);
      if (this.courseType == 10) {
        if (period.files && period.files.length) {
          // 预览图文课的第一个文件
          this.$refs.fileList?.onPreview(period.files[0]);
          return;
        }
        let data = await this.$services.CourseService.getPeriodContent(period);
        this.chapter_content = data.course_content;
        this.showContentDialog = true;
      } else {
        if (this.courseType == 16) {
          if (!type) {
            type = 2;
          }
        } else if (!type) {
          type = 1;
        }
        await this.$services.CourseService.watchVideo(
          period,
          this.courseType,
          this.course_id,
          type,
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
.chapter-content {
  &:last-child {
    margin-bottom: 0;
  }
  .period-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .limitDiv {
    position: absolute;
    right: 10px;
    top: -10px;
    color: #9a9a9a;
    font-size: 14px;
  }

  .opacity {
    opacity: 0.5;
  }
  .period-title-wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    &:hover {
      color: $primary-color;
    }
    &.disabled {
      cursor: default;
    }
  }
  .period-title {
    flex: 1;
    font-size: 16px;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 0;
  }
  .period-try {
    background: #fede55;
    border-radius: 14px;
    color: #433c39;
    font-size: 12px;
    height: 22px;
    line-height: 22px;
    padding: 0 10px;
    margin-right: 5px;
  }
  .period-point {
    width: 5px;
    height: 5px;
    background-color: $primary-color;
    border-radius: 100%;
    display: inline-block;
    vertical-align: middle;
    margin-right: 18px;
  }
  .period-course-type {
    height: 22px;
    background: #ffffff;
    border: 1px solid $primary-color;
    border-radius: 12px;
    line-height: 20px;
    font-size: 12px;
    color: $primary-color;
    padding: 0 5px;
    box-sizing: border-box;
    margin-right: 8px;
  }
  .period-info {
    // display: flex;
    // align-items: center;
    font-size: 14px;
    color: #666666;
    // padding: 16px 0 0 0;
    // justify-content: space-between;
  }
  .period-btn {
    flex-shrink: 0;
    padding-left: 10px;
    .btn {
      border-radius: 30px;
      background: linear-gradient(91deg, #ff5858 11.16%, #ff6b00 60.83%, #ff3743 102.99%);
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: #fff;
      padding: 10px 24px;
      cursor: pointer;
    }
    .disabled {
      background: #d0d0d8;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    }
  }
  .tip {
    padding-bottom: 16px;
    font-size: 14px;
    line-height: 20px;
    color: #999;
  }
  .serve-warp {
    display: flex;
    .serve-item {
      font-size: 14px;
      line-height: 20px;
      // padding-top: 18px;
      display: flex;
      align-items: center;
      color: #333;
      cursor: pointer;
      span {
        margin-left: 4px;
      }
      &::before {
        content: '';
        display: inline-block;
        margin: 0 16px;
        width: 1px;
        height: 12px;
        background: #d9d9d9;
      }
      &:first-child {
        &::before {
          display: none;
        }
      }
    }
    .serve-item:hover {
      color: #ff4242;
    }
  }
  .period-file a {
    font-size: 14px;
    color: rgba(89, 89, 89, 1);
    &:hover {
      color: $primary-color;
    }
  }
  .chapter-expand .chapter-content {
    display: block;
  }
  .period-file {
    padding-left: 15px;
    margin-top: 8px;
  }
  .file-type {
    margin-right: 5px;
  }
  .period-teacher {
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-left: 10px;
    padding-left: 10px;
    position: relative;
    flex-grow: 1;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      width: 1px;
      height: 16px;
      background: #cccccc;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .period-state {
    color: #666;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    .line {
      display: inline-block;
      width: 1px;
      height: 16px;
      background: #d9d9d9;
      margin: 0 16px;
    }
    .state {
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
        display: block;
        margin: 0 8px 0 0;
      }
    }
    .notStart {
      color: #666;
    }
    .inClass {
      color: #ff5858;
    }
    .end {
      color: #000;
    }
  }
  .operate {
    display: inline-block;
    height: 32px;
    color: $primary-color;
    line-height: 30px;
    border-radius: 16px;
    border: 1px solid rgba($primary-color, 0.5);
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;

    &:hover:not(.disabled) {
      background-color: $primary-color-08;
    }

    &.small {
      width: 90px;
    }

    &.big {
      width: 132px;

      &:first-child {
        margin-right: 10px;
      }
    }
    &.disabled,
    &.not-begin {
      color: #cccccc;
    }

    &.not-begin {
      border: none;
    }

    &.disabled {
      border: 1px solid rgba(204, 204, 204, 0.5);
      cursor: default;
    }

    &.living {
      border: none;
      .img-living {
        width: 14px;
        margin-right: 10px;
      }
    }
  }
  .progress-wrap {
    width: 64px;
    display: inline-block;
    overflow: hidden;
    margin-left: 16px;
    flex-shrink: 0;
    .progress {
      margin-right: 8px;
      vertical-align: text-bottom;
      margin-top: 1px;
    }
    > svg,
    > span {
      float: left;
    }
    .el-icon-success {
      color: $primary-color;
      margin-right: 8px;
      float: left;
      margin-top: 0px;
      font-size: 18px;
    }
  }
}
</style>
